<div class="flex h-[calc(100dvh-48px)] min-h-0 flex-col gap-4 p-4">
  <div class="flex flex-none items-center justify-between gap-4">
    <app-breadcrumbs location="Users" title="Dashboard" [isLoading]="isLoading" [divider]="false" />

    <button
      matButton="filled"
      color="primary"
      data-test-id="user-management-dashboard-create-user"
      [disabled]="isLoading"
      (click)="setCreateMode(true)"
    >
      Create user
    </button>
  </div>

  <mat-divider />

  @if (isLoading) {
    <div class="flex flex-1 min-h-0 items-center justify-center">
      <app-spinner size="lg" />
    </div>
  } @else {
    <div class="flex flex-1 min-h-0 flex-row gap-4">
      <mat-card class="h-full min-h-0 w-96 min-w-96 max-w-96 flex-none">
        <mat-card-content class="h-full min-h-0">
          <div class="flex h-full min-h-0 flex-col">
            <app-users-filter
              [users]="users"
              [clients]="clients"
              (usersFilterChangeSignal)="handleFilterChange($event)"
            />
            <div class="flex-1 min-h-0">
              <app-users-list [users]="filteredUsers" [clients]="clients" [selectedUserId]="selectedUserId" />
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card class="h-full min-h-0 flex-1 min-w-0">
        <mat-card-content class="h-full min-h-0">
          <div class="flex h-full min-h-0 flex-col">
            <div class="flex-1 min-h-0">
              @if (createMode) {
                <app-create-user
                  class="block h-full min-h-0"
                  [clients]="clients"
                  (createUserSignal)="refreshUsers($event)"
                />
              } @else if (selectedUser) {
                <app-edit-user
                  class="block h-full min-h-0"
                  [user]="selectedUser"
                  [clients]="clients"
                  (updateUserSignal)="refreshUsers()"
                />
              } @else {
                <div class="flex flex-col justify-center items-center h-full">
                  <p>Select a user from the list</p>
                </div>
              }
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  }
</div>
